// AIDEV-NOTE: Central theme configuration for Radix UI and custom styles
export const themeConfig = {
  // Radix UI theme settings
  radix: {
    appearance: 'dark' as const,
    accentColor: 'blue' as const,
    radius: 'medium' as const,
    scaling: '100%' as const,
  },
  
  // AIDEV-NOTE: Custom color tokens matching Tailwind config
  colors: {
    tournament: {
      gold: '#FFD700',
      silver: '#C0C0C0',
      bronze: '#CD7F32',
    },
    status: {
      win: '#10B981',  // green-500
      loss: '#EF4444', // red-500
      draw: '#6B7280', // gray-500
    },
  },
  
  // AIDEV-NOTE: Consistent spacing scale
  spacing: {
    xs: '0.5rem',   // 8px
    sm: '1rem',     // 16px
    md: '1.5rem',   // 24px
    lg: '2rem',     // 32px
    xl: '3rem',     // 48px
    '2xl': '4rem',  // 64px
  },
  
  // AIDEV-NOTE: Breakpoints matching Tailwind defaults
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
} as const;

// AIDEV-NOTE: Type-safe theme config type
export type ThemeConfig = typeof themeConfig;
